import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialPoll: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 28.955h32v1.52H0Zm24.38-27.43v1.52h-1.53v22.86h1.53v1.52h4.57v-1.52h1.52V3.045h-1.52v-1.52zm-9.14 21.33h1.52v1.52h-1.52Zm0-4.57h1.52v1.52h-1.52Zm0-4.57h1.52v1.52h-1.52Zm0-4.57h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M16.76 9.145h1.52v3.04h-1.52v1.53h1.52v3.05h-1.52v1.52h1.52v3.05h-1.52v1.52h1.52v3.05h1.53V7.615h-1.53v-1.52h-4.57v1.52h3.05z\"/><path fill=\"currentColor\" d=\"M18.28 27.425v-1.52h-3.04v-1.53h-1.53v-3.04h1.53v-1.53h-1.53v-3.04h1.53v-1.53h-1.53v-3.05h1.53v-1.52h-1.53v-3.05h-1.52v18.29h1.52v1.52zM7.62 16.765h1.52v9.14H7.62Zm-4.57 9.14h4.57v1.52H3.05Zm0-10.67h4.57v1.53H3.05Zm-1.53 1.53h1.53v9.14H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialPoll
